export var LoginType;
(function (LoginType) {
    LoginType["PASSWORD"] = "password";
    LoginType["SSO"] = "sso";
    LoginType["VERIFICATION_CODE"] = "verificationCode";
})(LoginType || (LoginType = {}));
